export default __webpack_public_path__ + "static/north-america-323e2f72c8ac3965620d8a1b6fe736b2.png";